<template>
	<div class="text-start roboto-flex-medium">
		<h2 class="mb-2 text-indigo-700 text-xl">🛠️ P0003: Fuel Volume Regulator A Control Circuit Low</h2>
		<p class="mb-4">This code means the signal controlling fuel volume is too low—like your engine’s asking for espresso and getting decaf. ☕️</p>
		<p class="mb-4">The culprit could be damaged wiring, a lazy fuel regulator, or even a poor connection somewhere in the circuit.</p>
		<p class="mb-4">Don’t panic—your engine isn’t starving yet. But if left unchecked, this could lead to poor fuel economy or a grumpy ride. Time to trace that voltage drop and give it some love. 🔍🔋</p>
	</div>
</template>
